var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-block",class:{ 'highlight': _vm.highlight , 'bg-secondary': _vm.hasBg }},[(_vm.title)?_c('h4',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }